export const CATEGORIE_DEFAULT = 'Short LC';

export const LISTE_CATEGORIE_PANNEAU = [
  {
    libelle: 'LC',
    couleur: '#DB19FF',
  },
  {
    libelle: 'LC Tournante',
    couleur: '#4B52FF',
  },
  {
    libelle: 'RESEAUX PERMANENT',
    couleur: '#F5C524',
  },
  {
    libelle: 'RESEAUX SEMI-PERMANENT',
    couleur: '#EF7049',
  },
  {
    libelle: 'RESEAU MIXTE',
    couleur: '#F44E3B',
  },
  {
    libelle: 'LC/LTO',
    couleur: '#4BD5FE',
  },
  {
    libelle: 'SMS',
    couleur: '#2DAA4A',
  },
  {
    libelle: 'AT',
    couleur: '#B72121',
  },
  {
    libelle: CATEGORIE_DEFAULT,
    couleur: '#0062b1',
  },
  {
    libelle: 'NOUVEAU',
    couleur: '#68BC00',
  },
  {
    libelle: 'ANCIEN',
    couleur: '#000000',
  },
];

export const BUDGET_ANNUEL = 'budgetAnnuel';
export const BUDGET_PRORATA = 'budgetProrata';

// à supprimer plus tard lorsque la gestion des utilisateurs sera okay
export const IDS_CLIENTS = [
  '0033ef7a-70b2-4914-82f3-5f9b03fc3684',
  '004967eb-1c52-4e1c-886a-487096782679',
  '01846823-a9bf-4111-a989-d9ca79df545a',
  '03ccc9ef-0d3b-475d-a8d5-c8a479060974',
  '6bffe036-00f3-405f-b8ee-6c554415078d',
];
